import React, { useState, useContext } from "react";
import {
  Row,
  Col,
  Card,
  Layout,
  Typography,
  Form,
  Input,
  Button,
  Divider,
  Space,
  message,
  InputNumber,
  Checkbox,
} from "antd";
import { LockOutlined, EyeTwoTone, EyeInvisibleOutlined, SolutionOutlined } from "@ant-design/icons";
import http from "../../../services/http";
import { AuthContext } from "../../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { IMAGES } from "../../../constants/images";
const { Title, Text, Link } = Typography;
const { Content } = Layout;

const styles = {
  row: {
    flexGrow: 1,
  },
};

export const Login = () => {
  const { iniciarSessao } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const realizarLogin = async (form) => {
    setLoading(true);
    form.os = "navegador";
    const api = await http("post", "v1/autenticacao/login", form);
    if (api.statusCode === 200) {
      await iniciarSessao(
        {
          logado: true,
          verificado: api?.response?.data?.verificado,
          acessos: api?.response?.data?.acessos,
          usuario: api?.response?.data?.user,
          token: api?.response?.data?.access_token,
          termos_pendentes: api?.response?.data?.termos_pendentes,
          formularios_pendentes: api?.response?.data?.formularios_pendentes,
          cadastro_atualizado: api?.response?.data?.cadastro_atualizado == 1 ? true : false,
          politicas_privacidade_pendentes: api?.response?.data?.politicas_privacidade_pendentes,
        },
        form?.remember ?? false
      );
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  const titulo = (
    <Content align="center">
      <img width={200} src={IMAGES.logoBlack} />
    </Content>
  );

  return (
    <Row justify="center" align="middle" className="full-width" style={styles?.row}>
      <Col xs={23} sm={18} md={14} lg={12} xl={8} xxl={6}>
        <Card title={titulo} style={{ marginBlock: 10 }}>
          <Title level={2} align="center">
            Login
          </Title>
          <Typography align="center" style={{ marginBottom: 20, fontSize: 16 }}>
            Portal do Colaborador
          </Typography>
          <Form name="login" initialValues={{ remember: false }} onFinish={realizarLogin} layout="vertical">
            <Form.Item label="Matrícula" name="matricula" rules={[{ required: true, message: "Digite sua matricula" }]}>
              <InputNumber
                controls={false}
                autoComplete="off"
                className="input-number"
                precision={0}
                prefix={<SolutionOutlined className="site-form-item-icon" />}
                size="large"
                min={1}
                disabled={loading}
                placeholder="Informe sua matrícula"
              />
            </Form.Item>

            <Form.Item
              className="FormItem"
              label="Senha"
              name="senha"
              rules={[{ required: true, message: "Digite sua senha!" }]}>
              <Input.Password
                size="large"
                autoComplete="off"
                prefix={<LockOutlined className="site-form-item-icon" />}
                placeholder="Digite sua senha"
                iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                disabled={loading}
              />
            </Form.Item>

            <Form.Item style={{ marginBottom: 10 }}>
              <Form.Item name="remember" valuePropName="checked" noStyle>
                <Checkbox>Manter login</Checkbox>
              </Form.Item>

              <Link type="link" onClick={() => window.open("/recuperacao-senha", "_blank")} style={{ float: "right" }}>
                Primeiro acesso ou esqueceu sua senha?
              </Link>
            </Form.Item>

            <Form.Item className="FormItem">
              <Button
                size="large"
                loading={loading}
                type="primary"
                htmlType="submit"
                style={{ width: "100%" }}
                className="btnLogin login-form-button">
                Entrar
              </Button>
            </Form.Item>
          </Form>

          <Divider />
          <Space size={20} direction="vertical" style={{ width: "100%" }}>
            <Col align="center">
              <Space wrap size={15}>
                <a
                  target="_blank"
                  href="https://apps.apple.com/br/app/cop%C3%A9rdia-colaborador/id6449134077?platform=iphone">
                  <img
                    src={"https://statics.coperdia.com.br/portal_colaborador/img/apple_store.png"}
                    width={140}
                    style={{ objectFit: "contain" }}
                  />
                </a>
                <a target="_blank" href="https://play.google.com/store/apps/details?id=br.com.coperdia.app_colaborador">
                  <img
                    src={"https://statics.coperdia.com.br/portal_colaborador/img/google_store.png"}
                    width={140}
                    style={{ objectFit: "contain" }}
                  />
                </a>
              </Space>
            </Col>

            <Content style={{ textAlign: "center" }}>
              <Text disabled>DPTO TI - COPÉRDIA &copy;</Text>
            </Content>
          </Space>
        </Card>
      </Col>
    </Row>
  );
};
